module.exports = __webpack_public_path__ + "img/yuni_website_logo.ea69c52b.svg";